import { getPeerReviewStateInteractions } from '../../helper/LearningSpaceServices/utils/stateInteractionHelper';
import { getCardQuestionForReviewForCorrespondingQuestion } from '../../helper/LearningSpaceServices/utils/getOfferData';

function convertToPeerQuestions(
  peerQuestionIndex,
  userId,
  peerQuestion,
  peerReviewStateInteractions
) {
  try {
    const reviewsReceived = [];
    peerReviewStateInteractions.forEach((interaction) => {
      let peerReview = {
        review: {}
      };
      if (interaction && interaction.reviews && interaction.reviews.length > 0) {
        peerReview = {
          review: {
            ...interaction.reviews[peerQuestionIndex],
            isAnonymous: interaction.isAnonymous
          }
        };
      }
      const review = {
        reviewedBy: {
          id: interaction.actorId,
          pid: interaction.actorId,
          actorType: interaction.actorType
        },
        review: peerReview.review
      };
      reviewsReceived.push(review);
    });
    const peerQuestionState = {
      ...peerQuestion,
      userId,
      reviewsReceived,
      children: []
    };

    return peerQuestionState;
  } catch (error) {
    throw new Error('Error in convertToPeerQuestionMongoSession ' + error);
  }
}

export function getPeerQuestionsForQuestion(offer, question, userId, states, stateInteractions) {
  try {
    const questionId = question._id;
    const questionState = states.find(state => state.contentId === questionId);
    // console.info('questionState...', questionId, questionState);
    const submissionId = questionState.submissions[0].submissionId || questionState.submissions[0]._id;
    const peerReviewStateInteractions = getPeerReviewStateInteractions(
      stateInteractions,
      questionId,
      userId,
      submissionId
    );
    const cardQuestionForReview = getCardQuestionForReviewForCorrespondingQuestion(
      offer,
      questionId
    );
    // console.info('cardQuestionForReview', cardQuestionForReview);
    if (!cardQuestionForReview) {
      return [];
    }
    const peerQuestions = cardQuestionForReview.children.map((peerQuestion, peerQuestionIndex) => convertToPeerQuestions(peerQuestionIndex, userId, peerQuestion, peerReviewStateInteractions)
    );
    // console.info('peerQuestions...', JSON.stringify(peerQuestions, null, 2));
    return peerQuestions;
  } catch (error) {
    console.log('Error in getPeerQuestionsForQuestion', error);
    throw error;
  }
}
